<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
        label-width="100px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="收支名称" prop="cptname"><el-input v-model="formParameter.cptname"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="收支时间" prop="cptdate">
              <el-date-picker v-model="formParameter.cptdate" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经办人" prop="cptemp">
              <el-select v-model="formParameter.cptemp" placeholder="默认自己">
                <el-option v-for="item in emps" :key="item.name" :label="item.name" :value="item.name">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="业务分类" @change="chgCtype" prop="ctype"><select-option-dictionary
                v-model="formParameter.ctype" dkey="cw-type" :multiple="false"
                :stringMode="true"></select-option-dictionary></el-form-item>
          </el-col>

        </el-row>

        <el-row>

          <el-col :span="12">
            <el-form-item label="账户" prop="cpttpname">
              <el-select v-model="formParameter.cpttpname" placeholder="请选择">
                <el-option v-for="item in cwcnts" :key="item.cpttpname" :label="item.cpttpname" :value="item.cpttpname">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="formParameter.ctype == '内部转帐'">
            <el-form-item label="to账户" prop="cpttpname2">
              <el-select v-model="cpttpname2" placeholder="请选择">
                <el-option v-for="item in cwcnts" :key="item.cpttpname" :label="item.cpttpname" :value="item.cpttpname">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="12">
            <el-form-item label="金额" prop="cptacount"><el-input v-model="formParameter.cptacount" autocomplete="off"
                placeholder="正数为收入,负数为支出"></el-input></el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remarks">
              <el-input type="textarea" rows="4" v-model="formParameter.remarks"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/cw2/cwcapitals.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";

export default {
  name: "edit",
  components: {
    popup,
    selectOptionDictionary,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      me: {},
      emps: [],
      cwcnts: [],
      cpttpname2: "",
      formParameter: {},
      rules: {
        //收支名称
        cptname: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 50,
            trigger: "blur",
          },
        ],
        //收支时间
        cptdate: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //金额(正数为收入,负数为支出)
        cptacount: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          }
        ],
        //业务类型(工资1、报销2)
        ctype: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 11,
            trigger: "blur",
          },
        ],
        cpttpname: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: "blur",
          },
        ]

      },
    };
  },
  methods: {

    chgCtype() {
      if (this.formParameter.ctype != '内部转款') {
        this.cpttpname2 = ""
      }
    },
    //打开弹框
    open(parameter, title, disabled, size) {

      this.formParameter = {}
      if (parameter.data) {
        this.formParameter = parameter.data;
      }
      this.cwcnts = parameter.cwcnts
      this.me = parameter.me
      // this.emps = parameter.emps
      this.emps = [{ "id": "1", "name": "Rick" }, { "id": "56493ffc15800a66a6962cc030c66eeb", "name": "李迪娜" }, { "id": "bc06b722d5037b9b7fced95bf2eeea45", "name": "杨烨" }]
      this.disabled = disabled;
      this.$refs.popup.open(title, "50%");

    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.formParameter = {}
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        if (!this.formParameter.id) {
          //添加
          let parameter = this.$utils.merger(this.formParameter);
          parameter.state = 0
          console.log("parameter", parameter)
          console.log("this.cpttpname2", this.cpttpname2)
          api.save(
            parameter,
            (response) => {

              this.formParameter = {}

              if (parameter.ctype == "内部转帐" && this.cpttpname2.length > 4) {
                parameter.cpttpname = this.cpttpname2
                parameter.cptacount = parameter.cptacount * (-1)
                console.log("parameter22", parameter)
                api.save(parameter, res => {
                  this.$utils.msg.success(res.msg);

                  this.confirmLoading = false;
                  this.$parent.list();
                  this.formParameter.cptacount = ''
                  this.formParameter.cptname = ''
                  this.formParameter.ctype = ''
                  this.formParameter.remarks = ''
                })

              } else {
                this.$utils.msg.success(response.msg);
                this.confirmLoading = false;
                this.$parent.list();
                this.formParameter.cptacount = ''
                this.formParameter.cptname = ''
                this.formParameter.ctype = ''
                this.formParameter.remarks = ''
              }
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          let parameter = this.$utils.merger(this.formParameter);
          parameter.state = 0
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.formParameter = {}
              this.confirmLoading = false;
              this.formParameter.cptacount = ''
              this.formParameter.cptname = ''
              this.formParameter.ctype = ''
              this.formParameter.remarks = ''
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
